export default {
    update(el, { arg, value }) {
        const field = arg;
        const errors = value;
        const oldValidationMessage = _(el.children).find(child => {
            return child.classList.contains('js-created-from-validation-field-directive');
        });

        oldValidationMessage && el.removeChild(oldValidationMessage);

        if (field in errors) {
            // Add "has-error" class to wrapping div (usually ".form-group")
            el.classList.add('has-error');

            // Create an error message div and append it to the ".form-group"
            let errorMessageBlock = document.createElement('span');
            errorMessageBlock.innerText = typeof errors[field] === 'string' ? errors[field] : errors[field][0];
            errorMessageBlock.classList.add('help-block');
            errorMessageBlock.classList.add('js-created-from-validation-field-directive');
            el.appendChild(errorMessageBlock);
        } else {
            el.classList.remove('has-error');
        }
    }
}
